import type { ProposalCase } from '@/lib/api/quality-types.js';
import {
  GenerationCaseText,
  type GenerationCredentialContext,
} from './GenerationCaseText.js';

export function GenerationCaseSteps({
  testCase,
  context,
}: {
  testCase: ProposalCase;
  context?: GenerationCredentialContext;
}) {
  const steps = testCase.test_steps_separated ?? [];
  return (
    <>
      {steps.length ? (
        <div className="space-y-2">
          <p className="font-medium">Steps & expected results</p>
          <ol className="list-decimal space-y-3 pl-5 marker:text-muted-foreground">
            {steps.map((step, index) => (
              <li key={index} className="pl-1">
                <p className="whitespace-pre-wrap">
                  <GenerationCaseText text={step.content} context={context} />
                </p>
                {step.expected ? (
                  <p className="mt-1 border-l-2 border-border pl-3 text-muted-foreground whitespace-pre-wrap">
                    <span className="sr-only">Expected result: </span>
                    <GenerationCaseText
                      text={step.expected}
                      context={context}
                    />
                  </p>
                ) : null}
              </li>
            ))}
          </ol>
        </div>
      ) : testCase.test_steps ? (
        <p className="whitespace-pre-wrap">
          <span className="font-medium">Steps:</span> {testCase.test_steps}
        </p>
      ) : null}
      {testCase.expected_result ? (
        <p className="whitespace-pre-wrap border-l-2 border-border pl-3">
          <span className="font-medium">Expected:</span>{' '}
          {testCase.expected_result}
        </p>
      ) : null}
    </>
  );
}
